import { z } from 'zod'

export const QuizQuestionFeedbackSchema = z.object({
  correct: z.string(),
  wrong: z.string()
})

export type QuizQuestionFeedbackEntity = z.infer<typeof QuizQuestionFeedbackSchema>
